import * as actionTypes from './actionTypes';
import { serviceUserMessage } from './services';
import { actionsModalError } from '@app/src/common/modalError';
import { fetchValidateAccess } from '@app/src/common/session';

const fetchUserMessageRequest = () => ({
  type: actionTypes.FETCH_USER_MESSAGE_REQUEST
});

const fetchUserMessageSuccess = (data) => ({
  type: actionTypes.FETCH_USER_MESSAGE_SUCCESS,
  data
});

const fetchUserMessageFailure = () => ({
  type: actionTypes.FETCH_USER_MESSAGE_FAILURE
});

export const closeUserFlashMessage = () => ({
  type: actionTypes.CLOSE_USER_MESSAGE_MODAL
});

export const openUserFlashMessage = () => ({
  type: actionTypes.OPEN_USER_MESSAGE_MODAL
});

export const fetchUserMessage = (): Function => {
  return async dispatch => {
    dispatch(fetchUserMessageRequest());
    await dispatch(fetchValidateAccess());
    try {
      const data = await serviceUserMessage.get();
      dispatch(fetchUserMessageSuccess(data && data[0]));
    } catch (e) {
      dispatch(fetchUserMessageFailure());
      dispatch(actionsModalError.openModalError());
    }
  }
}